import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiAppointmentFormSectionDTO,
  AppointmentFormSectionDTO,
} from "@lib/strapi/dtos/components/sections/appointmentFormSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class AppointmentFormSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiAppointmentFormSectionDTO,
  ): Promise<AppointmentFormSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new AppointmentFormSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.successMessage = await parseStrapiContent(strapiData.successMessage);
    return dto;
  }
}
